import { computed, ref } from 'vue';

const unreadCount = ref(0);
const isIntercomEnabled = ref(false);

export function onIntercomReady() {
  isIntercomEnabled.value = true;
  if (window.Intercom) {
    window.Intercom('onUnreadCountChange', (count: number) => {
      unreadCount.value = count;
    });
  }
}

export default function useIntercom() {
  const hasUnreadMessages = computed(() => unreadCount.value > 0);

  function showIntercom() {
    if (window.Intercom) {
      window.Intercom('showNewMessage');
    }
  }

  return {
    unreadCount,
    hasUnreadMessages,
    isIntercomEnabled,
    showIntercom,
  };
}
